import { TimeInterval } from "@/app/utils";
import { Radio, Select } from "antd";
import { useMemo } from "react";
import { useWindowSize } from "@/hooks/window-size";

type IntervalOption = {
  label: string;
  value: string;
};

export function IntervalSelector({
  callback,
  preferSelect,
  value,
}: {
  callback: (interval: number) => void;
  preferSelect?: boolean;
  value?: number;
}) {
  const windowSize = useWindowSize();
  const options = useMemo(() => getOptions(), []);
  const useSelect = preferSelect ?? windowSize.width < 560;
  const selectedValue = String(value ?? TimeInterval.Min15);

  if (useSelect) {
    return (
      <Select<string>
        size="small"
        value={selectedValue}
        style={{ minWidth: 78 }}
        options={options}
        onChange={(value) => callback(Number(value))}
      />
    );
  }

  return (
    <>
      <Radio.Group
        key={`r-buttons-time-interval`}
        onChange={(e) => callback(Number(e.target.value))}
        value={selectedValue}
        options={options}
        size="small"
        optionType="button"
        block={false}
      />
    </>
  );
}

export function IntervalSelectorMonitoring({
  clickable,
  callback,
  preferSelect,
  value,
}: {
  clickable: boolean | undefined;
  callback: (interval: number) => void;
  preferSelect?: boolean;
  value?: number;
}) {
  const windowSize = useWindowSize();
  const options = useMemo(() => getOptionsMonitoring(), []);
  const useSelect = preferSelect ?? windowSize.width < 560;
  const selectedValue = String(value ?? TimeInterval.Min5);

  if (useSelect) {
    return (
      <Select<string>
        size="small"
        value={selectedValue}
        style={{ minWidth: 78 }}
        options={options}
        onChange={(value) => callback(Number(value))}
        disabled={clickable != undefined ? !clickable : undefined}
      />
    );
  }

  return (
    <>
      <Radio.Group
        key={`r-buttons-time-interval`}
        onChange={(e) => callback(Number(e.target.value))}
        value={selectedValue}
        options={options}
        size="small"
        optionType="button"
        block={false}
        disabled={clickable != undefined ? !clickable : undefined}
      />
    </>
  );
}

function getOptions(): IntervalOption[] {
  return [
    {
      label: "15M",
      value: String(TimeInterval.Min15),
    },
    {
      label: "30M",
      value: String(TimeInterval.Min30),
    },
    {
      label: "H1",
      value: String(TimeInterval.Hour1),
    },
    {
      label: "H4",
      value: String(TimeInterval.Hour4),
    },
    {
      label: "D",
      value: String(TimeInterval.Day1),
    },
  ];
}

function getOptionsMonitoring(): IntervalOption[] {
  return [
    {
      label: "5M",
      value: String(TimeInterval.Min5),
    },
    {
      label: "15M",
      value: String(TimeInterval.Min15),
    },
    {
      label: "H1",
      value: String(TimeInterval.Hour1),
    },
    {
      label: "H4",
      value: String(TimeInterval.Hour4),
    },
    {
      label: "D",
      value: String(TimeInterval.Day1),
    },
  ];
}
